export const PROFILE_FORM_FIELD_ID = {
  STREET_ADDRESS: 'streetAddress',
  POSTAL_CODE: 'postalCode',
  LOCALITY: 'locality',
  FAMILY_NAME: 'familyName',
  GIVEN_NAME: 'givenName',
  EMAIL: 'email',
  MOBILE: 'mobile',
  PHONE: 'phone',
} as const;

export const DEFAULT_FORM_FIELD_ID = {
  BOOKING_NOTES: 'bookingNotes',
  CAPACITY: 'capacity',
  GIFTCARD: 'giftCard',
  NATIONAL_ID: 'nationalId',
  DISCOUNT_CODE: 'discountCode',
  ...PROFILE_FORM_FIELD_ID,
} as const;

export const GUEST_FORM_FIELD_ID = 'guestName';
